import React, {useEffect, useState} from 'react';
import './style.scss';
import CouriersShiftPopup from "../CouriersShiftPopup";
import {useSelector} from "react-redux";
import CourierShiftControlCentersPopup from "../CourierShiftControlCentersPopup/index.js";
import {isShowControlCenterSearch} from "../../../services/userModel.js";

const CouriersShiftWithControlCenterPopup = ({itemType, roles, isOpen, onClose}) => {
    const [controlCenter, setControlCenter] = useState('');
    const controlCentersAll = useSelector(state => state.restaurant.data.controlCenters);
    const selectedControlCenterMulti = useSelector(state => state.restaurant.data.selectedControlCenterMulti);

    useEffect(() => {
        if(selectedControlCenterMulti && selectedControlCenterMulti.length === 1) {
            setControlCenter(selectedControlCenterMulti[0]);
        }

        //eslint-disable-next-line
    }, [isOpen]);

    const filteredControlCenters = () => {
        if(selectedControlCenterMulti && selectedControlCenterMulti.length) {
            return controlCentersAll
                .filter(cc => selectedControlCenterMulti.includes(cc.controlCenterId));
        }
        return controlCentersAll;
    }

    return (
        <div>
            {(isShowControlCenterSearch() && !!controlCentersAll.length ? !controlCenter : false) && (
                <CourierShiftControlCentersPopup
                    isOpen={isOpen}
                    onClose={onClose}
                    setControlCenter={setControlCenter}
                    controlCenter={controlCenter}
                    controlCenters={filteredControlCenters().map(cc => ({value: cc.name, key: cc.controlCenterId}))}
                />
            )}
            {(isShowControlCenterSearch() && !!controlCentersAll.length ? controlCenter : true) && (
                <CouriersShiftPopup
                    itemType={itemType}
                    roles={roles}
                    isOpen={isOpen}
                    onClose={onClose}
                    controlCenterFilter={controlCenter}
                    selectedControlCenter={controlCenter}
                    enableMultiMode
                />
            )}
        </div>
    )
}

export default CouriersShiftWithControlCenterPopup;
